import styled, { css } from 'styled-components';

export const Container = styled.div<{ $narrow?: boolean }>`
  max-width: ${({ theme }) => theme.widths.max};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing[8]};

  ${({ $narrow, theme }) =>
    $narrow &&
    css`
      max-width: ${theme.widths.narrow};
    `}

  @media (max-width: 600px) {
    padding: 0 ${({ theme }) => theme.spacing[5]};
  }
`;
